import { memo } from 'react';
import { CheckIcon, CalendarIcon } from './icons';
import { ContactForm } from './ContactForm';

const BENEFITS = [
  '100% free consultation - zero obligation',
  'Personalized plan recommendations',
  'Expert advice from a licensed & experienced agent',
  'Quick response time'
];

/**
 * Connect — "Let's Connect / Ready to find the right coverage?" split section:
 * benefit bullets and the optional Book a Consultation (Calendly) block on the
 * left, the Get in Touch form card on the right.
 */
export const Connect = memo(({ name, firstName, calendlyHref, onSubmit }) => {
  return (
    <section className="cw-section section-connect" id="contact">
      <div className="cw-container connect-inner">
        <div className="connect-copy reveal">
          <p className="section-eyebrow">Let’s Connect</p>
          <h2 className="section-title">Ready to find the right coverage?</h2>
          <p className="connect-sub">
            Get in touch {firstName ? `with ${firstName} ` : ''}for personalized insurance guidance tailored to your
            needs. No obligation, no pressure - just honest advice.
          </p>
          <ul className="connect-benefits">
            {BENEFITS.map(benefit => (
              <li key={benefit}>
                <span className="benefit-mark">
                  <CheckIcon size={12} />
                </span>
                {benefit}
              </li>
            ))}
          </ul>
          {calendlyHref && (
            <div className="connect-booking">
              <h3>Prefer to pick a time?</h3>
              <p>Schedule a meeting for a time that works for you - zero obligation.</p>
              <a className="btn btn-primary" href={calendlyHref} target="_blank" rel="noopener noreferrer">
                <CalendarIcon size={14} />
                Book a Consultation
              </a>
            </div>
          )}
        </div>
        <div className="connect-form reveal">
          <ContactForm name={name} firstName={firstName} onSubmit={onSubmit} idPrefix="cf360-connect" />
        </div>
      </div>
    </section>
  );
});
